import { useLocation } from 'react-router-dom'

export function useUtmUrl(url, locationContent = undefined) {
  const location =
    locationContent != undefined ? locationContent : useLocation()
  const utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid']
  const temp = []

  if (location.search !== '') {
    let params = location.search.slice(1).split('&')

    for (let i = 0; i < utm.length; i++) {
      var param = params.find((x) => x.indexOf(utm[i]) !== -1)

      if (param) temp.push(param)
    }

    if (url.indexOf('?') === -1) {
      return url + '?' + temp.join('&')
    }

    return url + '&' + temp.join('&')
  }

  return url
}

export default useUtmUrl
